import type {
  CheckoutPropsPurchaseWithCampaign,
  CheckoutPropsPurchaseWithSku,
} from '@trmediaab/checkout';
import { Checkout } from '@trmediaab/checkout';
import { Box, Button } from '@trmediaab/zebra';

type CheckoutBoxProps = {
  cancelText?: string;
  onCancel?: () => void;
} & (
  | Omit<CheckoutPropsPurchaseWithSku, 'mode' | 'containerVariant'>
  | Omit<CheckoutPropsPurchaseWithCampaign, 'mode' | 'containerVariant'>
);

const CheckoutBox = ({ cancelText, onCancel, ...props }: CheckoutBoxProps) => (
  <>
    <Checkout mode="purchase" containerVariant="wide" {...props} />
    {cancelText != null && onCancel != null && (
      <Box px={[3, 4, null, 5]}>
        <Box
          maxWidth="checkout.innerMaxWidth"
          width="100%"
          mx="auto"
          mt={['3,5', null, 4]}
        >
          <Button
            display="flex"
            bc="offersTertiary"
            width="100%"
            onClick={onCancel}
          >
            {cancelText}
          </Button>
        </Box>
      </Box>
    )}
  </>
);

export default CheckoutBox;
